// @ts-nocheck

import React from 'react';
import dynamic from 'next/dynamic';
import HeadNext from 'next/head';
import NextDefaultError from 'next/error';
import useServerEnv from '@magalu/rave/config/useServerEnv';
import useClientEnv from '@magalu/rave/config/useClientEnv';

import { client } from '@magalu/rave/graphql';
import { parseHeaders, shouldRender, middlewareClientExecutor, middlewareServerExecutor } from '@magalu/rave/utils';
import { withEventsLayer } from '@magalu/rave/hocs';
import { ErrorBoundary } from '@magalu/rave/errorBoundary';
import { ComponentErrorBoundary } from '@magalu/rave/errorBoundary';

import events, { config as eventsConfig } from '../../events';

import { Head, LazyLoading, ActivityDetection } from '@magalu/rave/components';

// Modules
import Button from '@magalu/ecomm-components/rave/Button';
import { Preconnect } from '@magalu/rave/components';
import GoogleTagManager from '@magalu/ecomm-components/rave/scripts/GoogleTagManager';
import { Script } from '@magalu/rave/components';
import AllIn from '@magalu/ecomm-components/rave/scripts/AllIn';
import Criteo from '@magalu/ecomm-components/rave/scripts/Criteo';
import Bing from '@magalu/ecomm-components/rave/scripts/Bing';
import TikTok from '@magalu/ecomm-components/rave/scripts/TikTok';
import RTBHouse from '@magalu/ecomm-components/rave/scripts/RTBHouse';
import Stewie from '@magalu/ecomm-components/rave/scripts/Stewie';
import SpotifyAdAnalytics from '@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics';
import Vwo from '@magalu/ecomm-components/rave/scripts/Vwo';
import Header from '@magalu/ecomm-components/rave/Header';
import EventPageViewDispatcher from '@magalu/ecomm-components/rave/EventPageViewDispatcher';
import SellerChat from '@magalu/ecomm-components/rave/SellerChat';
import PageLoading from '@magalu/ecomm-components/components/PageLoading';
import AdsFetcher from '@magalu/ecomm-components/features/ads/components/AdsFetcher';
import Row from '@magalu/ecomm-components/components/Row';
import Heading from '@magalu/ecomm-components/rave/Heading';
import Image from '@magalu/ecomm-components/components/Image';
import Footer from '@magalu/ecomm-components/rave/Footer';
/**
* for client modules in typescript, need to use dynamic<T> as any
* read: https://github.com/vercel/next.js/issues/4515
*/
const CookieSecurity = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/scripts/CookieSecurity'), {
  ssr: false
});
/**
* for client modules in typescript, need to use dynamic<T> as any
* read: https://github.com/vercel/next.js/issues/4515
*/
const Hotjar = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/scripts/Hotjar'), {
  ssr: false
});
/**
* for client modules in typescript, need to use dynamic<T> as any
* read: https://github.com/vercel/next.js/issues/4515
*/
const Loader = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/Loader'), {
  ssr: false
});
/**
* for client modules in typescript, need to use dynamic<T> as any
* read: https://github.com/vercel/next.js/issues/4515
*/
const StateLoader = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/StateLoader'), {
  ssr: false
});
/**
* for client modules in typescript, need to use dynamic<T> as any
* read: https://github.com/vercel/next.js/issues/4515
*/
const AdsBanner = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/AdsBanner'), {
  ssr: false
});
/**
* for client modules in typescript, need to use dynamic<T> as any
* read: https://github.com/vercel/next.js/issues/4515
*/
const Showcase = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/Showcase'), {
  ssr: false
});
/**
* for client modules in typescript, need to use dynamic<T> as any
* read: https://github.com/vercel/next.js/issues/4515
*/
const BackToTop = dynamic<any>(() =>
  import('@magalu/ecomm-components/components/BackToTop'), {
  ssr: false
});


// Data Source
import PageQuery from './query.json';

// Data Source Configs
import { configs as dataSourceConfigs } from '../../datasource/config';
const { cachePolicies = {}, localTypeDefs,  linkMiddlewares = [] } = dataSourceConfigs as any;

import { getParsedQuery, useRouter, useCookies, withRouter, getDeviceInfo } from '@magalu/rave/router';


import {
    getGlobalClassName, routeInfo, getComponents, getHeadProps,
    dataSource, getPageVariables, middlewaresArgs,
    manifest, config as raveConfig, componentsList
  } from './settings';

import routes from '../../rave-routes';



const Container = (props : Record<string, any>  = {}) => {

  const { client: clientConfig } = useClientEnv();
  const route = useRouter();

  // Filter out non-DOM props from incoming props before any usage
  const {
    componentsList,
    appConfig,
    clientConfig: _,
    fetchPriority,
    isServerRequest,
    middlewaresExecuted,
    stopRender,
    ...rest
  } = props;
  
  // Override props with cleaned version
  props = rest;
  
  const pageProps = { ...rest, appConfig: raveConfig, clientConfig, isServerRequest, manifest, route };

  const headProps = getHeadProps(pageProps);

  const componentProps = getComponents(pageProps);
  const className = getGlobalClassName(pageProps);
  const gridStyleHtml = {__html: `#500{display: grid;grid-template-areas: 'header header header' '. content .' 'footer footer footer';grid-template-columns: 1fr 100% 1fr;grid-template-rows: auto minmax(100vh, max-content) auto;}`}


  return (
    <>
      <HeadNext>
        <style dangerouslySetInnerHTML={gridStyleHtml}/>
      </HeadNext>
  
      <div id="500" className={className}>
          <Head {...props} {...headProps} />
        
            <header { ...{"style":{"gridArea":"header"}} }>
                
                
                
                <ComponentErrorBoundary componentId="header-button-0">
                <Button { ...props} {...(componentProps['header-button-0']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-preconnect-1">
                <Preconnect { ...props} {...(componentProps['header-preconnect-1']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-google-tag-manager-2">
                <GoogleTagManager { ...props} {...(componentProps['header-google-tag-manager-2']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-script-3">
                <Script { ...props} {...(componentProps['header-script-3']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-all-in-4">
                <AllIn { ...props} {...(componentProps['header-all-in-4']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-criteo-5">
                <Criteo { ...props} {...(componentProps['header-criteo-5']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-bing-6">
                <Bing { ...props} {...(componentProps['header-bing-6']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                <ActivityDetection {...componentProps['header-cookie-security-7'].csr.props}>
                
                <ComponentErrorBoundary componentId="header-cookie-security-7">
                <CookieSecurity { ...props} {...(componentProps['header-cookie-security-7']?.props || {})}/>
                </ComponentErrorBoundary>
                </ActivityDetection>
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-tik-tok-8">
                <TikTok { ...props} {...(componentProps['header-tik-tok-8']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-rtbhouse-9">
                <RTBHouse { ...props} {...(componentProps['header-rtbhouse-9']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-stewie-10">
                <Stewie { ...props} {...(componentProps['header-stewie-10']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-spotify-ad-analytics-11">
                <SpotifyAdAnalytics { ...props} {...(componentProps['header-spotify-ad-analytics-11']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                <ActivityDetection {...componentProps['header-hotjar-12'].csr.props}>
                
                <ComponentErrorBoundary componentId="header-hotjar-12">
                <Hotjar { ...props} {...(componentProps['header-hotjar-12']?.props || {})}/>
                </ComponentErrorBoundary>
                </ActivityDetection>
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-vwo-13">
                <Vwo { ...props} {...(componentProps['header-vwo-13']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                <ActivityDetection {...componentProps['header-loader-14'].csr.props}>
                
                <ComponentErrorBoundary componentId="header-loader-14">
                 
                <Loader { ...props} {...(componentProps['header-loader-14']?.props || {})}>
                
                
                
                <ComponentErrorBoundary componentId="header-loader-14-children-page-loading-0">
                <PageLoading { ...props} {...(componentProps['header-loader-14-children-page-loading-0']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                 
                </Loader>
                </ComponentErrorBoundary>
                </ActivityDetection>
                
                
                
                <ActivityDetection {...componentProps['header-state-loader-15'].csr.props}>
                
                <ComponentErrorBoundary componentId="header-state-loader-15">
                 
                <StateLoader { ...props} {...(componentProps['header-state-loader-15']?.props || {})}>
                
                <ActivityDetection {...componentProps['header-state-loader-15-children-page-loading-0'].csr.props}>
                
                <ComponentErrorBoundary componentId="header-state-loader-15-children-page-loading-0">
                <PageLoading { ...props} {...(componentProps['header-state-loader-15-children-page-loading-0']?.props || {})}/>
                </ComponentErrorBoundary>
                </ActivityDetection>
                
                 
                </StateLoader>
                </ComponentErrorBoundary>
                </ActivityDetection>
                
                
                <LazyLoading {...componentProps['header-ads-banner-16'].csr.props} _moduleId="header-ads-banner-16">
                
                
                <ComponentErrorBoundary componentId="header-ads-banner-16">
                <AdsBanner { ...props} {...(componentProps['header-ads-banner-16']?.props || {})}/>
                </ComponentErrorBoundary>
                
                </LazyLoading>
                
                
                
                
                <ComponentErrorBoundary componentId="header-header-17">
                 
                <Header { ...props} {...(componentProps['header-header-17']?.props || {})}>
                {shouldRender(componentProps['header-header-17-children-showcase-0']) &&
                <LazyLoading {...componentProps['header-header-17-children-showcase-0'].csr.props} _moduleId="header-header-17-children-showcase-0">
                
                
                <ComponentErrorBoundary componentId="header-header-17-children-showcase-0">
                <Showcase { ...props} {...(componentProps['header-header-17-children-showcase-0']?.props || {})}/>
                </ComponentErrorBoundary>
                
                </LazyLoading>
                }
                 
                {shouldRender(componentProps['header-header-17-children-showcase-1']) &&
                <LazyLoading {...componentProps['header-header-17-children-showcase-1'].csr.props} _moduleId="header-header-17-children-showcase-1">
                
                
                <ComponentErrorBoundary componentId="header-header-17-children-showcase-1">
                <Showcase { ...props} {...(componentProps['header-header-17-children-showcase-1']?.props || {})}/>
                </ComponentErrorBoundary>
                
                </LazyLoading>
                }
                 
                </Header>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-event-page-view-dispatcher-18">
                <EventPageViewDispatcher { ...props} {...(componentProps['header-event-page-view-dispatcher-18']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="header-seller-chat-19">
                <SellerChat { ...props} {...(componentProps['header-seller-chat-19']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
            </header>
            <section { ...{"style":{"gridArea":"content"}} }>
                
                
                
                <ComponentErrorBoundary componentId="content-ads-fetcher-0">
                <AdsFetcher { ...props} {...(componentProps['content-ads-fetcher-0']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
                
                
                
                <ComponentErrorBoundary componentId="content-row-1">
                 
                <Row { ...props} {...(componentProps['content-row-1']?.props || {})}>
                
                
                
                <ComponentErrorBoundary componentId="content-row-1-children-heading-0">
                <Heading { ...props} {...(componentProps['content-row-1-children-heading-0']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                 
                
                
                
                <ComponentErrorBoundary componentId="content-row-1-children-heading-1">
                <Heading { ...props} {...(componentProps['content-row-1-children-heading-1']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                 
                
                
                
                <ComponentErrorBoundary componentId="content-row-1-children-heading-2">
                <Heading { ...props} {...(componentProps['content-row-1-children-heading-2']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                 
                
                
                
                <ComponentErrorBoundary componentId="content-row-1-children-image-3">
                <Image { ...props} {...(componentProps['content-row-1-children-image-3']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                 
                
                
                
                <ComponentErrorBoundary componentId="content-row-1-children-button-4">
                <Button { ...props} {...(componentProps['content-row-1-children-button-4']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                 
                </Row>
                </ComponentErrorBoundary>
                
                
                
            </section>
            <footer { ...{"style":{"gridArea":"footer"}} }>
                
                <ActivityDetection {...componentProps['footer-back-to-top-0'].csr.props}>
                
                <ComponentErrorBoundary componentId="footer-back-to-top-0">
                <BackToTop { ...props} {...(componentProps['footer-back-to-top-0']?.props || {})}/>
                </ComponentErrorBoundary>
                </ActivityDetection>
                
                
                
                
                
                <ComponentErrorBoundary componentId="footer-footer-1">
                <Footer { ...props} {...(componentProps['footer-footer-1']?.props || {})}/>
                </ComponentErrorBoundary>
                
                
                
            </footer>
      </div>
    </>
  )
};


export default withRouter(
  withEventsLayer(
    Container,
    {
      routeInfo: routeInfo,
      events: events(),
      eventsCustomConfig: eventsConfig,
      dataStoreSetupKey: "userInfo",
    }
  ),
  { ...routeInfo, manifest },
  false,
  routes
);
